export const SidebarTitle = {
  DASHBOARD: 'Dashboard',
  MY_PRACTICE: 'My Practice',
  SETTINGS: 'Settings',
  PATIENTS: 'Patients',
  ECGS: 'ECGs',
  PPG: 'PPG',
  STUDY_ANALYSIS: 'Study Analysis',
  PROFILE_FORM: 'Profile Form',
  CALENDAR: 'Calendar',
  FAQ_PAGE: 'FAQ Page',
  BAR_CHART: 'Bar Chart',
  PIE_CHART: 'Pie Chart',
  LINE_CHART: 'Line Chart',
  GEOGRAPHY_CHART: 'Geography Chart',
  ECG_ANALYZE: 'Analyze ECGs',
  CONNECT_FACILITY: 'Connect Facility',
  CONNECT_PATIENT: 'Connect Patient',
  REGISTER_ADMIN: 'Register Admin',
  REQUESTS: 'Requests',
  PARTNER_CONNECT: 'Connect',
} as const;
